<h3>Recursos</h3>
<div class="card">
    <div class="card-header">Descargas</div>
    <div class="card-body">
        <ul>
            <li><a href="{{downloadsBaseUrl}}"
                    target="_blank">Impresion de Documentos</a></li>
        </ul>

    </div>
</div>

<div class="card mt-2">
    <div class="card-header">Aplicaciones</div>
    <div class="card-body">
        <ul>
            <li>
                <a [href]="repartidorUrl()" target="_blank">Repartidores</a>
                <button
                    type="button"
                    class="btn btn-link btn-sm ms-2 p-0 align-baseline"
                    (click)="copyRepartidorUrl()"
                    aria-label="Copiar enlace de Repartidores"
                    title="Copiar enlace de Repartidores">
                    <i class="fa fa-copy" aria-hidden="true"></i>
                </button>
            </li>
        </ul>

    </div>
</div>